import { InputBase, MenuItem, Select, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { IFieldOption } from '../../../models/form/form';
import { IFieldProps } from './InputField';

const CustomInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3)
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '9px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderRadius: 4,
            boxShadow: `0 0 0 0.1rem rgba(26,119,210,255)`
        }
    }
}));

const SelectField = ({ field, onChange }: IFieldProps) => {
    const [selectedOptions, setSelectedOptions] = useState<number[]>([]);

    useEffect(() => {
        if (!selectedOptions.length) return;

        onChange && onChange(field.options.filter((option) => selectedOptions.includes(option.id)));
    }, [selectedOptions]);

    return (
        <Select
            value={selectedOptions}
            onChange={({ target: { value } }) => {
                setSelectedOptions(typeof value === 'string' ? value.split(',').map((v) => Number(v)) : (typeof value === 'number') ? [value] : value);
            }}
            required={field.required}
            input={<CustomInput></CustomInput>}
            fullWidth
            multiple={field.multiselect}
        >
            {field.options.map((option: IFieldOption | string) => (
                <MenuItem sx={{ whiteSpace: "normal" }} key={`option_${(option as IFieldOption).value}`} value={(option as IFieldOption).id}>
                    {(option as IFieldOption).value}
                </MenuItem>
            ))}
        </Select>
    );
};

export default SelectField;
